import React, {Component} from 'react'
import './IntroPara.css'

export default class IntroPara extends Component {
    render() {
        return (
            <div className="intro-p-container">
                <p>You can often find me harnessing the power of React, JavaScript ES6, Node.js, Express, HTML5, and CSS3 to create clean and responsive full stack websites with interactive elements. </p>
                <p>I find beauty in the intersection of creativity and programming where elegant and engaging websites are born. I also believe in the importance of lifelong education and feel most satisfied after trying something new or solving a puzzle.</p>
            </div>
        )
    }
}